import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Concept() {
  return (
    <section className="concept p-100 text_whitegreen back_black">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1>The Concept Behind Building Plank App</h1>
            <p>
              The Plank app was built specifically for those with an inclination
              towards being fit and active, with exercise being a component of
              their daily life. Planking is among the top exercises that have
              multiple benefits, and yet there has been no solution that covers
              it specifically.
            </p>
            <p>
              Our client understood the problem, and to solve this, TekRevol
              provided the digital route. We proposed this incredible digital
              solution which promised to translate the amazing idea into a
              complete digital solution, serving the end users perfectly.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/pure-plank/concept.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={665}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Concept;
